import type { ActiveProductByExpirationItem, ActiveProductsByExpirationMonth } from './shopping_cart.initial';
import { ISuggestions, ISuggestionsRequest } from './model';

/** Normaliza el objeto `YYYY-MM` → arrays. El API a veces lo envía en la raíz y a veces dentro de `user_profile`. */
function parseActiveProductsByExpirationMonth(raw: unknown): ActiveProductsByExpirationMonth {
    if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
        return {};
    }
    const out: ActiveProductsByExpirationMonth = {};
    for (const [monthKey, value] of Object.entries(raw)) {
        out[monthKey] = Array.isArray(value) ? (value as ActiveProductByExpirationItem[]) : [];
    }
    return out;
}

export const getCalculatedSuggestion = async (
    payload: ISuggestionsRequest,
    token: string
): Promise<ISuggestions> => {
    const baseURL = process.env.REACT_APP_API_PAYMENT_METHODS!;
    const xApiKey = process.env.REACT_APP_XAPIKEY_TRANSACTION_AUTHORIZE!;

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            ...payload
        }),
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': xApiKey,
        }
    };
    const urlRequest = `${baseURL}suggested_calculator/suggested_calculator`;
    const res = await fetch(urlRequest, requestOptions);
    const json = (await res.json()) as ISuggestions & Record<string, unknown>;
    const rawBuckets =
        json.active_products_by_expiration_month ??
        json.user_profile?.active_products_by_expiration_month;
    const active_products_by_expiration_month = parseActiveProductsByExpirationMonth(rawBuckets);

    return {
        ...json,
        active_products_by_expiration_month,
    };
};


export const exportSuggestedTable = async (user_id: number, email: string, token: string) => {
    const baseURL = process.env.REACT_APP_SEPOMEX!;
    const xApiKey = process.env.REACT_APP_SEPOMEX_API_KEY!;

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-api-key': xApiKey,
        }
    };
    const urlRequest = `${baseURL}get_colonies_for_user?country=MX&user_id=${user_id}&create_pdf=false`
    const res = await fetch(urlRequest, requestOptions);
    console.log(res)
    const json = await res.json(); // Convertir la respuesta a JSON

    if (!json.data || json.data.length === 0) {
        alert("No hay datos para exportar.");
        return;
    }

    // Convertir JSON a CSV
    const convertToCSV = (data, email) => {
         // Primera fila: Email
         const emailRow = `Email,${email}\n\n`;  // Dos saltos de línea después del email
        // Definir los headers personalizados
        const headers = "Categoria,Colonia,Estado,Total de propiedades\n";

        const capitalizeFirstLetter = (str) => {
            if (!str) return ""; // Manejar valores null o undefined
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        const rows = data.map(row => {
            return [
                `"${capitalizeFirstLetter(row.name.replace(/"/g, '""'))}"`, // categoria
                `"${row.colony.replace(/"/g, '""')}"`, // Colonia
                `"${row.state.replace(/"/g, '""')}"`, // Estado
                row.total_properties // Total de propiedades (es número, no necesita comillas)
            ].join(",");
        }).join("\n");
        return emailRow + headers + rows;
    };

    const csvData = convertToCSV(json.data, email);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "colonias.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
